/*
 * Minimum guest counts for per-person catering products.
 *
 * window.cateringMinimums (rendered by snippets/minimum-guests.liquid) maps
 * variant id to the minimum quantity. This script does three things:
 *
 *   1. Product page: starts the quantity box at the minimum, stops the
 *      minus button and typed values from going below it, and shows a
 *      short "Minimum 50 guests" note under the box.
 *   2. Cart requests: every add or change request the theme sends to
 *      Shopify (product form, quick add, quick view, cart page, cart
 *      drawer) passes through window.fetch, so quantities are raised to
 *      the minimum before they reach the cart. Removing a line (quantity
 *      0) is always allowed.
 *   3. Existing cart: on load, any line already below its minimum is
 *      corrected once and the page refreshed.
 */
(function () {
  var minimums = window.cateringMinimums || {};
  if (!Object.keys(minimums).length) return;

  function minimumFor(variantId) {
    if (variantId === undefined || variantId === null) return 1;
    return minimums[String(variantId)] || 1;
  }

  function clamp(variantId, quantity) {
    var qty = parseInt(quantity, 10);
    var min = minimumFor(variantId);
    if (isNaN(qty) || qty <= 0) return qty;
    return qty < min ? min : qty;
  }

  function variantFromKey(key) {
    return String(key).split(':')[0];
  }

  /* ---------- 1. Product page quantity boxes ---------- */

  function currentVariantId(form) {
    var idField = form && form.querySelector('input[name="id"], select[name="id"]');
    return idField ? idField.value : null;
  }

  function noteFor(input, min) {
    var box = input.closest('.product-form__quantity') || input.parentElement.parentElement;
    if (!box) return;
    var note = box.querySelector('.minimum-guests-note');
    if (min > 1) {
      if (!note) {
        note = document.createElement('div');
        note.className = 'minimum-guests-note text-sm mt-1.5 opacity-80';
        box.appendChild(note);
      }
      note.textContent = 'Minimum ' + min + ' guests';
    } else if (note) {
      note.remove();
    }
  }

  function applyToInput(input) {
    var formId = input.getAttribute('form');
    var form = formId ? document.getElementById(formId) : input.closest('form');
    var min = minimumFor(currentVariantId(form));
    if (min <= 1) return;

    input.min = min;
    if (parseInt(input.value, 10) < min || !input.value) {
      input.value = min;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    noteFor(input, min);

    var box = input.parentElement;
    if (!window.Alpine || !box || box.dataset.minimumGuestsBound) return;
    var data;
    try { data = Alpine.$data(box); } catch (e) { return; }
    if (!data || typeof data.minus !== 'function') return;
    box.dataset.minimumGuestsBound = '1';

    var refreshPrice = function (ctx) {
      if (typeof ctx.updatePrice === 'function') ctx.updatePrice();
    };
    data.min = min;
    if (parseInt(data.qty, 10) < min) data.qty = min;
    data.minus = function (value) {
      var qty = parseInt(this.qty, 10) || min;
      this.qty = qty - (value || 1) < min ? min : qty - (value || 1);
      refreshPrice(this);
    };
    data.invalid = function (el) {
      var number = parseFloat(el.value);
      if (!Number.isInteger(number) || number < min) this.qty = min;
      if (this.max && number > this.max) this.qty = parseInt(this.max, 10);
      refreshPrice(this);
    };
  }

  function applyToProductPage() {
    var inputs = document.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) applyToInput(inputs[i]);
  }

  /* ---------- 2. Guard every cart request ---------- */

  function isCartRoute(url, name) {
    return typeof url === 'string' && url.indexOf('/cart/' + name) !== -1;
  }

  function fixJsonBody(text, route) {
    var data;
    try { data = JSON.parse(text); } catch (e) { return text; }
    if (route === 'add') {
      if (Array.isArray(data.items)) {
        data.items.forEach(function (item) {
          item.quantity = clamp(item.id, item.quantity === undefined ? 1 : item.quantity);
        });
      } else if (data.id !== undefined) {
        data.quantity = clamp(data.id, data.quantity === undefined ? 1 : data.quantity);
      }
    } else if (route === 'update' && data.updates && !Array.isArray(data.updates)) {
      Object.keys(data.updates).forEach(function (key) {
        data.updates[key] = clamp(variantFromKey(key), data.updates[key]);
      });
    } else if (route === 'change' && data.id !== undefined && String(data.id).indexOf(':') !== -1) {
      data.quantity = clamp(variantFromKey(data.id), data.quantity);
    }
    return JSON.stringify(data);
  }

  function fixFormBody(body) {
    var id = body.get('id');
    if (id === null) return body;
    var qty = body.get('quantity');
    body.set('quantity', clamp(id, qty === null ? 1 : qty));
    return body;
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var route = isCartRoute(url, 'add') ? 'add'
      : isCartRoute(url, 'change') ? 'change'
      : isCartRoute(url, 'update') ? 'update'
      : null;

    if (!route || !init || !init.body) return nativeFetch.apply(this, arguments);

    var body = init.body;
    if (body instanceof FormData || body instanceof URLSearchParams) {
      init.body = fixFormBody(body);
      return nativeFetch.call(this, input, init);
    }

    if (typeof body === 'string') {
      var parsed;
      try { parsed = JSON.parse(body); } catch (e) { parsed = null; }

      /* change.js by line number: look the line up in the live cart first */
      if (route === 'change' && parsed && parsed.line !== undefined && parsed.id === undefined) {
        var self = this, args = arguments;
        return nativeFetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var item = cart.items[parseInt(parsed.line, 10) - 1];
            if (item) parsed.quantity = clamp(item.variant_id, parsed.quantity);
            init.body = JSON.stringify(parsed);
            return nativeFetch.call(self, input, init);
          })
          .catch(function () { return nativeFetch.apply(self, args); });
      }

      init.body = fixJsonBody(body, route);
    }
    return nativeFetch.call(this, input, init);
  };

  /* ---------- 3. Correct a cart that is already below minimum ---------- */

  function correctExistingCart() {
    nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var changed = false;
        cart.items.forEach(function (item) {
          var fixed = clamp(item.variant_id, item.quantity);
          if (fixed !== item.quantity) {
            updates[item.key] = fixed;
            changed = true;
          }
        });
        if (!changed) return;
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          var stamp = 'minimum-guests-corrected';
          if (!sessionStorage.getItem(stamp)) {
            sessionStorage.setItem(stamp, '1');
            window.location.reload();
          }
        });
      })
      .catch(function () {});
  }

  /* ---------- Boot ---------- */

  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = window.setTimeout(function () {
      scheduled = null;
      applyToProductPage();
    }, 150);
  }

  document.addEventListener('alpine:initialized', schedule);
  window.addEventListener('load', function () {
    schedule();
    correctExistingCart();
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') schedule();
  }, true);
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
